document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pack-upgrade]');
  if (!button) return;

  event.preventDefault();
  button.disabled = true;

  const line = Number(button.dataset.line);
  const variantId = Number(button.dataset.variantId);
  const quantity = Number(button.dataset.quantity);

  const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || '/cart';
  const addUrl = (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add';
  const changeUrl = (typeof routes !== 'undefined' && routes.cart_change_url) || '/cart/change';

  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  let added = false;

  try {
    const addResponse = await fetch(`${addUrl}.js`, {
      method: 'POST',
      headers: json,
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    });

    if (!addResponse.ok) throw new Error(`add.js returned ${addResponse.status}`);
    added = true;

    const changeResponse = await fetch(`${changeUrl}.js`, {
      method: 'POST',
      headers: json,
      body: JSON.stringify({ id: String(button.dataset.currentVariantId), quantity: 0 }),
    });

    if (!changeResponse.ok) throw new Error(`change.js returned ${changeResponse.status}`);

    // Re-render the drawer from a fresh section render.
    const drawerResponse = await fetch(`${cartUrl}?section_id=cart-drawer`);
    if (!drawerResponse.ok) throw new Error(`section render returned ${drawerResponse.status}`);

    const drawerHtml = new DOMParser().parseFromString(await drawerResponse.text(), 'text/html');
    const freshDrawer = drawerHtml.querySelector('#CartDrawer');
    const liveDrawer = document.querySelector('#CartDrawer');

    if (!freshDrawer || !liveDrawer) throw new Error('Could not find #CartDrawer');

    liveDrawer.innerHTML = freshDrawer.innerHTML;

    const wrapper = document.querySelector('cart-drawer');
    if (wrapper) {
      wrapper.classList.remove('is-empty');
      const inner = wrapper.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }

    // Refresh the header cart count.
    try {
      const bubbleResponse = await fetch(`${cartUrl}?section_id=cart-icon-bubble`);
      if (bubbleResponse.ok) {
        const bubbleHtml = new DOMParser().parseFromString(await bubbleResponse.text(), 'text/html');
        const freshBubble = bubbleHtml.querySelector('#cart-icon-bubble');
        const liveBubble = document.querySelector('#cart-icon-bubble');
        if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
      }
    } catch (bubbleError) {
      console.warn('Cart bubble refresh skipped:', bubbleError);
    }
  } catch (error) {
    console.error('Pack upgrade failed:', error);
    if (added) {
      window.location.reload();
    } else {
      button.disabled = false;
    }
  }
});
